import { render, staticRenderFns } from "./innova.vue?vue&type=template&id=36139c18"
import script from "./innova.vue?vue&type=script&lang=js"
export * from "./innova.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports